export const OPPORTUNITY_CENTER = 'opportunity_center'
